export default {
  mutateCommonObj (state, payload) {
    state.commonObj = Object.assign({}, state.commonObj, payload)
  },
  mutateFormLoad (state, payload) {
    state.static = Object.assign({}, state.static, payload)
  },
  localizeCommonDropdown (state, payload) {
    state.commonObj.serviceTypeList = state.commonObj.serviceTypeList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.eventTypeList = state.commonObj.eventTypeList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.eventList = state.commonObj.eventList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.patientCategoryList = state.commonObj.patientCategoryList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.stallTypeList = state.commonObj.stallTypeList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.disabilityTypeList = state.commonObj.disabilityTypeList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.patientList = state.commonObj.patientList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.stallList = state.commonObj.stallList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.employerList = state.commonObj.employerList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.assistiveDeviceList = state.commonObj.assistiveDeviceList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.supplierInfoList = state.commonObj.supplierInfoList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.idscCenterList = state.commonObj.idscCenterList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.donationTypeList = state.commonObj.donationTypeList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.areaTypeList = state.commonObj.areaTypeList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.municipalityList = state.commonObj.municipalityList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.circularList = state.commonObj.circularList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.groupList = state.commonObj.groupList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.instituteList = state.commonObj.instituteList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.skillList = state.commonObj.skillList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.educationLevelList = state.commonObj.educationLevelList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.degreeList = state.commonObj.degreeList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.educationalBoardList = state.commonObj.educationalBoardList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.educationalBoardList = state.commonObj.educationalBoardList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.genderList = state.commonObj.genderList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
    state.commonObj.maritalStatusList = state.commonObj.maritalStatusList.map(item => {
      const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
      return Object.assign({}, item, tmp)
    })
  }
}
